// extracted by mini-css-extract-plugin
module.exports = {"appContainer":"styles_appContainer__1ehrM","spin":"styles_spin__3Z1sl"};